export const GRAYLOG_URI: String = "";
export const STRING_LEVEL_ERROR: String = "Error";
export const HOST: String = "hub-front-end";
